import React, { MouseEvent } from "react";
import { isMobile } from "react-device-detect";
import { Link, useHistory } from "react-router-dom";
import { PlanType, SubscriptionProductType } from "../../../models/plans";
import {
  formatPrice,
  formatPlanName,
} from "../../../middleware/common-functions";
import { PlanItem } from "../../../models/user";
import { PricingTable } from "../purchaseplan/plans";

type PlansProps = {
  plans: PlanType[];
  selectedPlan?: SubscriptionProductType;
  handlePlanSelect?: (ev: MouseEvent<HTMLButtonElement>) => void;
  isBuyUrl?: boolean;
  products: SubscriptionProductType[];
};

const Plans: React.FC<PlansProps> = ({
  plans,
  selectedPlan,
  handlePlanSelect,
  isBuyUrl,
  products,
}) => {
  const history = useHistory();
  const plans_data: PlanItem[] = JSON.parse(
    localStorage.getItem("plans_data") || "{}",
  );

  const pupularPlanId = "3";
  const free_trial = plans_data.find((plan) => plan.id === "2");
  const navigateToPayment = (plan_id: string) => {
    history.push("/payment/" + plan_id);
  };
  if (isMobile) {
    return (
      <div className="pricing_table">
        {products.length > 0
          ? products.map((product) => {
              const plan = plans.find((plan) => plan.id === product.id);
              if (!plan || !plan.price_amount) {
                return null;
              }
              const formatedPrice = formatPrice(product.price!);

              return (
                <div className="" key={`plan.name.card${product.id}`}>
                  {product.id === pupularPlanId ? (
                    <span className="popular_span">Most Popular </span>
                  ) : null}
                  <div
                    className={`card ${
                      product.id === pupularPlanId ? "popular" : ""
                    }`}
                  >
                    <div
                      className="card-body"
                      onClick={() => {
                        navigateToPayment(product.plan_id);
                      }}
                    >
                      <h5 style={{ whiteSpace: "pre-line" }}>
                        {formatPlanName(plan.name)} Plan
                      </h5>
                      <h3>
                        USD ${formatedPrice.whole}.{""}
                        <sup>{formatedPrice.decimal}</sup>
                      </h3>

                      <Link
                        to={`/payment/${product.plan_id}`}
                        className={`buy_now_btn btn btn-${
                          product.id === pupularPlanId ? "" : "outline-"
                        }danger btn-block py-3`}
                      >
                        {" "}
                        Buy Now
                      </Link>
                      <small className="text-muted text-center d-block">
                        <i
                          className="text-success fas fa-badge-dollar"
                          aria-hidden="true"
                        ></i>{" "}
                        {free_trial?.days || "14"}-day money-back guarantee{" "}
                        <br /> Does not auto-renew
                      </small>
                    </div>
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item">
                        <i
                          className="text-success fa fa-check"
                          aria-hidden="true"
                        ></i>{" "}
                        Students Access: {plan.students} students
                      </li>
                      <li className="list-group-item">
                        {" "}
                        <i
                          className="text-success fa fa-check"
                          aria-hidden="true"
                        ></i>{" "}
                        Access on Your Computer, TV, <br /> Phone, and Tablet
                      </li>
                      <li className="list-group-item">
                        <i
                          className="text-success fa fa-check"
                          aria-hidden="true"
                        ></i>{" "}
                        Spanish, French, and German Titles
                      </li>
                      <li className="list-group-item">
                        <i
                          className="text-success fa fa-check"
                          aria-hidden="true"
                        ></i>{" "}
                        Cancel Anytime
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })
          : null}
      </div>
    );
  }
  return (
    <div className={`pricing_table ${isBuyUrl ? "col-lg-12" : "col-lg-10"}`}>
      {handlePlanSelect ? (
        <h4 className="black_text">
          Purchase any of the membership packages below.
        </h4>
      ) : null}
      {handlePlanSelect ? (
        <ul className="black_text">
          <li>Select your preferred membership package and make payment.</li>
          <li>You can cancel your subscription at any time.</li>
          <li>
            You can also subscribe using a purchase order on the Teacher's
            Discovery website by{" "}
            <a
              href="https://www.teachersdiscovery.com/product/29270"
              target="_blank"
              rel="noreferrer"
            >
              <u>clicking here</u>
            </a>
            .
          </li>
          {isBuyUrl ? (
            ""
          ) : (
            <li>
              Renewing will ADD on to the end of your current expiration date.
            </li>
          )}
        </ul>
      ) : null}
      <PricingTable
        products={products}
        free_trial={free_trial}
        plans={plans}
        showHeader={true}
        pupularPlanId={pupularPlanId}
        selectedPlan={selectedPlan}
        handlePlanSelect={handlePlanSelect}
        isBuyUrl={isBuyUrl}
      />
    </div>
  );
};

export default Plans;
